/** Tailwind class for OpenSearch snippet marks in the sidebar and universal search. */
export const SEARCH_SNIPPET_HIGHLIGHT_CLASS = 'bg-yellow-100'

/** Shared `<mark>` styling for query/OpenSearch snippet highlights (sidebar + modal). */
export const SEARCH_SNIPPET_HIGHLIGHT_MARK_CLASS = `rounded-sm ${SEARCH_SNIPPET_HIGHLIGHT_CLASS} px-0.5 font-semibold`

/**
 * Canvas search rects use the same hue as sidebar snippets but with multiply so
 * the raster plan text stays readable (see `HighlightStrokesOverlay`).
 */
export const PLAN_SET_SEARCH_CANVAS_HIGHLIGHT_FILL_CLASS = 'bg-yellow-100'

/** Applied to the canvas highlight layer wrapper, not individual rects. */
export const PLAN_SET_SEARCH_CANVAS_HIGHLIGHT_BLEND_CLASS = 'mix-blend-multiply'
